const STORAGE_KEY = "consentGiven";

export function isConsentGiven() {
  return !!sessionStorage.getItem(STORAGE_KEY);
}

export function setConsentGiven(given: boolean) {
  if (given) {
    sessionStorage.setItem(STORAGE_KEY, "true");
  } else {
    sessionStorage.removeItem(STORAGE_KEY);
  }
}
